import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, PopoverController } from 'ionic-angular'; 
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app/app-config';
import { UserserviceProvider } from '../../providers/userservice';
import { MassePage } from '../masse/masse';
import { QuickviewPage } from '../quickview/quickview';

@Component({
  selector: 'page-typeopen',
  templateUrl: 'typeopen.html',
})
export class TypeopenPage {
productname: string;
producttype: string;
windowtype: string;
typeopen: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, public http: HttpClient, public appConfig: AppConfig, public userService: UserserviceProvider, public loadingCtrl: LoadingController, public popoverCtrl: PopoverController) {
  
    this.windowtype = this.navParams.get('windowtype');
    this.productname = this.navParams.get('productname');
    this.producttype = this.navParams.get('producttype');
    console.log( this.productname, this.producttype, this.windowtype); 
  
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad FenstertypPage');
  }
  
      presentQuickView() {
    this.myChoice = {productname: this.productname, producttype :this.producttype, windowtype:this.windowtype, typeopen:this.typeopen}
    const popover = this.popoverCtrl.create(QuickviewPage, this.myChoice, {cssClass: 'popover-top-right'});
    popover.present();
  } 
  
  
    ionViewWillEnter() : void
   {
    this.getProductTypes();
   }
   
    clicktype2(typeopen) {
    this.navCtrl.push(MassePage, {
    typeopen: typeopen,
    windowtype: this.windowtype,
    productname: this.productname,
    producttype: this.producttype
    });
  } 
   
   
     getProductTypes(){
  this.presentLoading();
  this.userService.getProductTypes2().subscribe((data : any) =>
      {
          this.types2 = data;
          console.dir(data);
          this.loading.dismiss();
      },
      (error : any) =>
      {
         console.dir(error);
        this.loading.dismiss();
      });
        }
        
     presentLoading() {
        this.loading = this.loadingCtrl.create({
        content: 'Please wait...'
        });
        this.loading.present();
    }
   
   
   doRefresh(refresher) {
   this.getProductTypes();
   refresher.complete();
   }

}



// WEBPACK FOOTER //
// ./src/pages/typeopen/typeopen.ts